import { CaptionPresetName } from './types';

export const PRESET_DISPLAY_NAMES: Record<CaptionPresetName, string> = {
  beast: 'Beast',
  snazzy: 'Snazzy',
  sleek: 'Sleek',
  bouncy: 'Bouncy',
  neo: 'Neo',
  sassy: 'Sassy',
  prof: 'Professional',
  funky: 'Funky',
  neon: 'Neon',
  corporate: 'Corporate',
  marker: 'Marker',
  romantic: 'Romantic',
  silicon: 'Silicon',
  sign: 'Sign',
  simpleBold: 'Simple Bold',
  custom: 'Custom'
};

export function getPresetDisplayName(presetName: CaptionPresetName): string {
  return PRESET_DISPLAY_NAMES[presetName] || presetName;
}

export function getPresetDisplayNames(): Record<CaptionPresetName, string> {
  return PRESET_DISPLAY_NAMES;
}
